import React, { useEffect } from 'react'
import { useForm, FormProvider } from 'react-hook-form';
import Form from '../components/Form/Form';
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiInputMoney from '../components/Form/UiInputMoney';
import UiInputDate from '../components/Form/UiInputDate';
import UiInputText from '../components/Form/UiInputText';
import UiInputList from '../components/Form/UiInputList';

const situacaoList = [
    { id: 'P', title: 'Em Aberto' },
    { id: 'G', title: 'Pago' },
    { id: 'B', title: 'Baixado' },
    { id: 'C', title: 'Cancelado' },
];

export default function BaixaBoletoForm(props: any) {
    const methods = useForm({
        defaultValues: props.data || {}
    });
    const { handleSubmit, watch, reset } = methods;
    const novoStatus = watch('novoStatus');

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputText size={12} name="pagadorNome" label="Pagador" readOnly />
                        <UiInputList
                            size={12}
                            name="novoStatus"
                            label="Nova Situação"
                            list={situacaoList}
                            idField="id"
                            titleField="title"
                        />
                        {(novoStatus === 'G' || novoStatus === 'B') && <>
                            <UiInputDate size={6} name="dataPagamento" label="Data do Pagamento" />
                            <UiInputMoney size={6} name="valorPago" label="Valor Pago" />
                        </>}
                        <input type="hidden" {...methods.register('boletoId')} />
                    </div>
                </WindowBody>
                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Confirmar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    );
}
